import Block from "@/components/wrappers/block"
import styles from "./annual-wheel.module.css"
import { useEffect, useState } from "react"
import Modal from "react-modal"
import modalStyles from "@/components/base/popup/popup.module.css"
import classNames from "classnames"
import Close from "@/components/common/icons/close"

export default function AnnualWheel({ block }) {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [modalKey, setModalKey] = useState(0)
  const [currentElement, setCurrentElement] = useState(-1)
  const [hasMounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const defaultColor = "#40b0ac"

  const customStyles = {
    overlay: {
      display: "flex",
      backgroundColor: "rgba(0, 0, 0, .5)",
      zIndex: 1000,
      alignItems: "center",
      justifyContent: "center"
    }
  }

  function openModal(key) {
    setModalKey(key)
    setModalIsOpen(true)
  }

  const Month = ({ modalKey, block }) => {
    return (
      <>
        <div className={styles.month}>
          <div
            className={styles.monthContent}
            onMouseEnter={() => {
              setCurrentElement(modalKey)
            }}
            onMouseLeave={() => {
              setCurrentElement(-1)
            }}
            onClick={() => {
              openModal(modalKey)
            }}>
            <h3 className="flex items-start justify-center mb-2">
              <div
                style={{
                  backgroundColor: block.attrs.color
                    ? block.attrs.color
                    : "#40b0ac"
                }}
                className={styles.dot}></div>
              {block.attrs.headline}
            </h3>
            <div
              className="mb-1 text-center"
              suppressHydrationWarning
              dangerouslySetInnerHTML={{
                __html: block.attrs.text.substring(0, 100) + "..."
              }}
            />
            <div className={styles.link}>{block.attrs.linkText}</div>
          </div>
        </div>
      </>
    )
  }

  if (!hasMounted) return null

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        style={customStyles}
        shouldReturnFocusAfterClose={true}
        shouldCloseOnOverlayClick={true}
        className={classNames(modalStyles.content, "p-8")}>
        <div
          className={modalStyles.click}
          onClick={() => setModalIsOpen(false)}>
          <div className={modalStyles.close}>
            <Close className="icon" />
          </div>
        </div>

        <h3 className="flex items-start">
          <div
            style={{
              backgroundColor: block.innerBlocks[modalKey].attrs.color
                ? block.innerBlocks[modalKey].attrs.color
                : "#40b0ac"
            }}
            className={styles.dot}></div>
          {block.innerBlocks[modalKey].attrs.headline}
        </h3>
        <div
          suppressHydrationWarning
          dangerouslySetInnerHTML={{
            __html: block.innerBlocks[modalKey].attrs.text
          }}
        />
      </Modal>

      <Block block={block}>
        <div className={styles.wheel}>
          <div className={styles.left}>
            <Month modalKey={0} block={block.innerBlocks[0]} />
            <Month modalKey={2} block={block.innerBlocks[2]} />
          </div>
          <div className={styles.middle}>
            <div className={styles.circle}>
              <svg
                width="408"
                height=""
                viewBox="0 0 408 408"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  className={classNames({
                    selected: currentElement !== 0 && currentElement != -1,
                    testar: currentElement == 0
                  })}
                  d="M204 37.3332C111.952 37.3332 37.333 111.952 37.333 204"
                  stroke={
                    block.innerBlocks[0].attrs.color
                      ? block.innerBlocks[0].attrs.color
                      : defaultColor
                  }
                  strokeWidth="72"
                />
                <path
                  className={classNames({
                    selected: currentElement !== 1 && currentElement !== -1
                  })}
                  d="M370.664 203.999C370.664 111.952 296.044 37.3328 203.997 37.3328"
                  stroke={
                    block.innerBlocks[1].attrs.color
                      ? block.innerBlocks[1].attrs.color
                      : defaultColor
                  }
                  strokeWidth="72"
                />
                <path
                  className={classNames({
                    selected: currentElement !== 2 && currentElement !== -1
                  })}
                  d="M37.3305 204C37.3305 296.047 111.95 370.666 203.997 370.666"
                  stroke={
                    block.innerBlocks[2].attrs.color
                      ? block.innerBlocks[2].attrs.color
                      : defaultColor
                  }
                  strokeWidth="72"
                />
                <path
                  className={classNames({
                    selected: currentElement !== 3 && currentElement !== -1
                  })}
                  d="M203.998 370.666C296.046 370.666 370.665 296.047 370.665 204"
                  stroke={
                    block.innerBlocks[3].attrs.color
                      ? block.innerBlocks[3].attrs.color
                      : defaultColor
                  }
                  strokeWidth="72"
                />

                <path
                  className={classNames({
                    selectedArrow:
                      currentElement !== 0 && currentElement !== -1,
                    testar: currentElement == 0
                  })}
                  d="M225.33 37.3333L203.997 74.6666L203.997 0L225.33 37.3333Z"
                  fill={
                    block.innerBlocks[0].attrs.color
                      ? block.innerBlocks[0].attrs.color
                      : defaultColor
                  }
                />
                <path
                  className={classNames({
                    selectedArrow: currentElement !== 1 && currentElement !== -1
                  })}
                  d="M370.668 225.333L333.335 204H408.001L370.668 225.333Z"
                  fill={
                    block.innerBlocks[1].attrs.color
                      ? block.innerBlocks[1].attrs.color
                      : defaultColor
                  }
                />
                <path
                  className={classNames({
                    selectedArrow: currentElement !== 2 && currentElement !== -1
                  })}
                  d="M37.332 182.666L74.6653 204L-0.00127411 204L37.332 182.666Z"
                  fill={
                    block.innerBlocks[2].attrs.color
                      ? block.innerBlocks[2].attrs.color
                      : defaultColor
                  }
                />
                <path
                  className={classNames({
                    selectedArrow: currentElement !== 3 && currentElement !== -1
                  })}
                  d="M182.664 370.667L203.997 333.333L203.997 408L182.664 370.667Z"
                  fill={
                    block.innerBlocks[3].attrs.color
                      ? block.innerBlocks[3].attrs.color
                      : defaultColor
                  }
                />
              </svg>
            </div>
          </div>
          <div className={styles.right}>
            <Month modalKey={1} block={block.innerBlocks[1]} />
            <Month modalKey={3} block={block.innerBlocks[3]} />
          </div>
        </div>
      </Block>
    </>
  )
}
